import Vue from 'vue';
import Vuetify from 'vuetify/lib';
// import Vuetify from 'vuetify/lib/framework'
// import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

// import Vuetify, { VBtn, VDivider, VIcon, VLayout, VSnackbar } from 'vuetify/lib'
//
// Vue.use(Vuetify, {
//     components: { VBtn, VDivider, VIcon, VLayout, VSnackbar }
// })
let isDark = localStorage.hasOwnProperty('isDark') ? JSON.parse(localStorage.getItem('isDark')) : false;

export default new Vuetify({
    theme: {
        defaultTheme: 'light',
        dark: isDark,
        themes: {
            light: {
                primary: '#7a7a7a',
                accent: '#7a7a7a',
                tbGreen: '#6aa84f',
                lightGreen: '#4caf50',
                lightRed: '#fc0d1b',
                lightBlack: '#212121',
                lightGrey: '#757575',
                greyLighten4: '#f5f5f5',
                message: '#1867c0',
            },
            dark: {
                primary: '#1e1f22',
                accent: '#7a7a7a',
                tbGreen: '#6aa84f',
                lightGreen: '#4caf50',
                lightRed: '#fc0d1b',
                red: '#f6475d',
                white: '#f0f0f0',
                lightBlack: '#212121',
                lightGrey: '#757575',
                greyLighten4: '#f5f5f5',
                message: '#1867c0',
            },
        },
    },
});
